import { IconButton, TextField } from '@mui/material';
import { forwardRef, useState } from 'react';

import { ReactComponent as EyeOffIcon } from 'src/assets/svg/eye-off.svg';

import type { PasswordFieldProps } from './types';

export const PasswordField = forwardRef<HTMLInputElement, PasswordFieldProps>(
    (
        {
            labelComponent,
            placeholder,
            required,
            error,
            helperText,
            fullWidth,
            disabled,
            value,
            onChange,
        },
        ref
    ) => {
        const [showText, setShowText] = useState<boolean>(false);

        const toggleShowText = () => setShowText((prev) => !prev);

        return (
            <TextField
                ref={ref}
                value={value}
                onChange={onChange}
                variant="standard"
                type={showText ? 'text' : 'password'}
                label={labelComponent}
                placeholder={placeholder}
                InputLabelProps={{ shrink: true }}
                fullWidth={fullWidth}
                required={required}
                error={error}
                helperText={helperText}
                disabled={disabled}
                InputProps={{
                    endAdornment: (
                        <IconButton onClick={toggleShowText} edge="end">
                            <EyeOffIcon />
                        </IconButton>
                    ),
                }}
            />
        );
    }
);
